<template>
    <div>
        <div class="setting-left" :style="`height:${columnH}px`">
            <ul>
                <li v-if="checkIndexPermission(permission, '/staterunEnrolSystem/enrolStuOnlineExamine')">
                    <router-link to="/main/primary/review/reviewOnline">线上审核</router-link>
                </li>
                <li v-if="checkIndexPermission(permission, '/staterunEnrolSystem/enrolStuAgainExamine') ||
                checkIndexPermission(permission, '/staterunEnrolSystem/enrolStuAdmitAndRemark')">
                    <router-link to="/main/primary/review/reviewOffline">线下审核</router-link>
                </li>
                <li v-if="checkIndexPermission(permission, '/staterunEnrolSystem/enrolStuPreAdmit')">
                    <router-link to="/main/primary/review/reviewReserve">预录取</router-link>
                </li>
            </ul>
        </div>
        <div class="setting-right" :style="`height:${columnH}px`">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import mixins from '@/mixins/windowResize';
    import baseMixin from '@/mixins/baseMixin.js'
    export default {
        name: "ReviewLayout",
        created(){
            if(this.checkIndexPermission(this.permission, '/staterunEnrolSystem/enrolStuOnlineExamine')) {
                this.$router.replace('/main/primary/review/reviewOnline');
            } else {
                this.$router.replace('/main/primary/review/reviewOffline');
            }
        },
        computed: {
            ...mapGetters(['permission'])
        },
        mixins:[mixins, baseMixin],
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/mixin";

    @include globalstyle;

    .setting-left {
        float: left;
        width: 12%;
        border-right: 1px solid #e6e6e6;

        .router-link-active {
            color: #20a0ff;
        }
        ul {
            margin: 0;
            li {
                a {
                    text-decoration: none;
                    display: block;
                    height: 56px;
                    line-height: 56px;
                    font-size: 14px;
                    color: #48576a;
                    padding: 0 20px;
                    cursor: pointer;
                    position: relative;
                    transition: border-color .3s,background-color .3s,color .3s;
                    box-sizing: border-box;
                    white-space: nowrap;
                    &:hover {
                        background-color: #d1dbe5;
                    }
                }
            }
        }

    }
    .setting-right {
        float: right;
        width: 86%;
      //  height: 730px;
        overflow-y: auto;
    }

</style>



// WEBPACK FOOTER //
// src/views/primary/review/ReviewLayout.vue